import script from "./ShopLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopLayout.vue?vue&type=script&setup=true&lang=js"

import "./ShopLayout.vue?vue&type=style&index=0&id=c1f9746c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1f9746c"]])

export default __exports__